import axios from '@/axios'

export default {
  fetchAll(params, id){
    return axios.get(`/purchase-details/all/${id}`, {params})
  },
  fetchLimit(params, id){
    return axios.get(`/purchase-details/limit/${id}`, {params})
  },  
  fetchById(id){
    return axios.get(`/purchase-details/${id}`)
  },    
  create(payload){
    return axios.post(`/purchase-details`, payload)
  },
  update(id, payload){
    return axios.put(`/purchase-details/${id}`, payload)
  },
  delete(id){
    return axios.delete(`/purchase-details/${id}`)
  }, 
  deleteMultiple(payload){
    return axios.delete(`/purchase-details`, payload)
  },
  fetchAllByReceiving(params){
    return axios.get(`/purchase-details/receive`, {params})
  }
}